import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { MosaicGridBone } from '../../organisms';

interface MosaicSkeletonProps {
    /** Nombre de colonnes */
    columns?: number;
    /** Nombre de lignes */
    rows?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
    /** Styles personnalisés */
    sxGrid?: SxProps<Theme>;
    /** Styles personnalisés */
    sxItem?: SxProps<Theme>;
}

export const MosaicSkeleton: React.FunctionComponent<MosaicSkeletonProps> = function ({
    columns = 3,
    rows = 3,
    sx = {},
    sxGrid = {},
    sxItem = {},
}) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 5,
                height: '100%',
                width: '100%',
                ...sx,
            }}
        >
            <MosaicGridBone
                columns={columns}
                rows={rows}
                sx={sxGrid}
                sxItem={sxItem}
            />
        </Box>
    );
};
